import { createClient } from 'graphql-ws'
import { boot } from 'quasar/wrappers'
import WebSocket from 'ws'
let wsClient
export default boot(({ app, ssrContext }) => {
  wsClient = createClient({
    url: process.env.API_WS,
    webSocketImpl: ssrContext ? WebSocket : undefined
  })
})
export { wsClient }
